import * as types from "./types";

const mutations = {
  [types.SET_USER](state, payload) {
    Object.assign(state, payload);
  },
  [types.SET_PROFILE](state, { "active-plans": plans, ...rest }) {
    state.profile = {
      plans,
      basePlan: plans.find((p) => p.planMaster.planType === "BASE"),
      ...rest,
    };
  },
  setCustomerData(state, payload) {
    state.customerData = payload;
  },
  setCustomerDataBySerialNo(state, payload) {
    state.customerDataBySerialNo = payload;
  },
  resetCustomerData(state, payload) {
    state.customerData = payload;
    state.customerDataBySerialNo = payload;
    state.storePaymentData = payload;
    state.profile = payload;
  },
  setPaymentData(state, payload) {
    state.storePaymentData = {};
    state.storePaymentData = payload;
  },
  [types.SET_BALANCE](state, walletBalance) {
    state.walletBalance = walletBalance;
  },
  [types.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
  },
};

export default mutations;
